module.exports = __webpack_public_path__ + "Raleway-500-Medium-Italic.ff3c8ca6aa39754108f3.ttf";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/assets/fonts/Raleway-500-Medium-Italic.ttf
// module id = ../../../../../src/assets/fonts/Raleway-500-Medium-Italic.ttf
// module chunks = styles